import { createSlice } from "@reduxjs/toolkit";
import storage from 'redux-persist/lib/storage';

const initialState = {
  logged: false,
  currentUser: {},
};

export const authSlice = createSlice({
  name: "authentication",
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      state.logged = true;
      state.currentUser = action.payload;
    },
    loginFailure: (state) => {
      state.logged = false;
      state.currentUser = null;
    },
    logOut: (state) => {
      state.logged = false;
      state.currentUser = {};
      storage.removeItem('token');
    },
  },
});

export const { loginSuccess, loginFailure, logOut } = authSlice.actions;
export default authSlice.reducer;
